module.exports = __webpack_public_path__ + "media/images/sme_vector-675f85d65b9ea2bd64004521542ec6ec.svg";